// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".minRowHeight[data-v-13fd547d] {\n  min-height: 20px;\n}\n.labelDivWidth[data-v-13fd547d] {\n  min-width: 6rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.labelDivWidth span.labelWidth[data-v-13fd547d] {\n  width: 4.5rem;\n}", ""]);
// Exports
module.exports = exports;
